import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Grid, IconButton } from "@mui/material";
import ScreenDropdown from "app/components/common/ScreenDropdown";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

import "./Screen4.css";
import screen4_left from "app/assets/Screen4_left.png";
import screen4_right from "app/assets/Screen4_right.png";
import OccupationBubbleChart from "./Screen4Graphs/OccupationBubbleChart";
import IndustryJobCounts from "./Screen4Graphs/IndustryJobCounts";
import {
  fetchIndustryData,
  updateIndustryTypeS3,
} from "../../7screen/redux/screen3/actions";

import {
  fetchAverageDataScreen4,
  fetchCountDataScreen4,
  fetchPercentDataScreen4,
  fetchGrowthDataScreen4,
} from "../../7screen/redux/screen4/actions";

import { changeScreenOrientation, updateDataSources } from "../../7screen/redux/ScreensCommon/actions";
import { logActivity } from "../redux/api/loggingAPI";
import { UserActivityConstants } from "api/UserActivityConstants";

const countData = {
  jobs: [
    23456,
    12145,
    11924,
    173846,
    177106,
    97948,
    320328,
    115922,
    45511,
    171623,
    54296,
    159890,
    32370,
    239112,
    63741,
    391607,
    33848,
    241122,
    69188,
    386944,
    1760,
  ],
  jobs_change: [
    -2068,
    1466,
    907,
    38556,
    30056,
    15040,
    51987,
    54447,
    7938,
    40559,
    12185,
    50499,
    10339,
    32396,
    17786,
    123701,
    24247,
    115900,
    26185,
    25048,
    1438,
  ],
  labels: [
    "Agriculture, Forestry, Fishing and Hunting",
    "Mining, Quarrying, and Oil and Gas Extraction",
    "Utilities",
    "Construction",
    "Manufacturing",
    "Wholesale Trade",
    "Retail Trade",
    "Transportation and Warehousing",
    "Information",
    "Finance and Insurance",
    "Real Estate and Rental and Leasing",
    "Professional, Scientific, and Technical Services",
    "Management of Companies and Enterprises",
    "Administrative and Support and Waste Management and Remediation Services",
    "Educational Services",
    "Health Care and Social Assistance",
    "Arts, Entertainment, and Recreation",
    "Accommodation and Food Services",
    "Other Services (except Public Administration)",
    "Government",
    "Unclassified Industry",
  ],
};
const percentData = {
  labels: [
    "Agriculture, Forestry, Fishing and Hunting",
    "Mining, Quarrying, and Oil and Gas Extraction",
    "Utilities",
    "Construction",
    "Manufacturing",
    "Wholesale Trade",
    "Retail Trade",
    "Transportation and Warehousing",
    "Information",
    "Finance and Insurance",
    "Real Estate and Rental and Leasing",
    "Professional, Scientific, and Technical Services",
    "Management of Companies and Enterprises",
    "Administrative and Support and Waste Management and Remediation Services",
    "Educational Services",
    "Health Care and Social Assistance",
    "Arts, Entertainment, and Recreation",
    "Accommodation and Food Services",
    "Other Services (except Public Administration)",
    "Government",
    "Unclassified Industry",
  ],
  percent: [
    -1,
    -5,
    2,
    3,
    5,
    19,
    5,
    7,
    12,
    -4,
    -5,
    -6,
    -11,
    -4,
    0,
    2,
    -3,
    -6,
    -18,
    -10,
    15,
  ],
};

class Screen4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crossFactorTypeSelected: "Education Groups",
      specializedSelected: "All Occupations",
      focusOccupation: "",
    };
  }

  refreshData() {
    this.props.fetchIndustryData();
    this.props.fetchAverageDataScreen4(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2
    );
    this.props.fetchCountDataScreen4(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.specializedSelected
    );
    this.props.fetchPercentDataScreen4(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.specializedSelected
    );
    this.props.fetchGrowthDataScreen4(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.crossFactorTypeSelected,
      this.state.specializedSelected
    );
  }

  componentDidMount() {
    this.refreshData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.regionSelected !== prevProps.regionSelected) {
      this.refreshData();
    }
    if (
      prevProps.jobTypeSelectedS2 !== this.props.jobTypeSelectedS2 ||
      prevProps.industryTypeSelectedS3 !== this.props.industryTypeSelectedS3
    ) {
      this.props.fetchAverageDataScreen4(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2
      );
      this.props.fetchCountDataScreen4(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2,
        this.state.specializedSelected
      );
      this.props.fetchPercentDataScreen4(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2,
        this.state.specializedSelected
      );
      this.props.fetchGrowthDataScreen4(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2,
        this.state.crossFactorTypeSelected,
        this.state.specializedSelected
      );
    }
  }

  handleIndustryTypeChange = (event) => {
    const {
      target: { value },
    } = event;
    let industryType = value;
    this.props.updateIndustryTypeS3(industryType);
    this.props.fetchAverageDataScreen4(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2
    );
    this.props.fetchCountDataScreen4(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.specializedSelected
    );
    this.props.fetchPercentDataScreen4(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.specializedSelected
    );
    this.props.fetchGrowthDataScreen4(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.crossFactorTypeSelected,
      this.state.specializedSelected
    );

    logActivity({
      screen : UserActivityConstants.SCREEN4.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action_target : industryType,
      action : UserActivityConstants.SCREEN4.ACTIONS.SELECT_INDUSTRY_TYPE
    })
  };

  handleCrossFactorTypeChange = (event) => {
    const {
      target: { value },
    } = event;
    let crossFactorType = value;
    this.state.crossFactorTypeSelected = crossFactorType;
    this.props.fetchGrowthDataScreen4(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      crossFactorType,
      this.state.specializedSelected
    );

    logActivity({
      screen : UserActivityConstants.SCREEN4.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action_target : crossFactorType,
      action : UserActivityConstants.SCREEN4.ACTIONS.SELECT_CROSS_FACTOR_TYPE
    })
  };

  handleSpecializedChange = (event) => {
    const {
      target: { value },
    } = event;
    let specialized = value;
    this.state.specializedSelected = specialized;
    this.props.fetchCountDataScreen4(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      specialized
    );
    this.props.fetchPercentDataScreen4(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      specialized
    );
    this.props.fetchGrowthDataScreen4(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.crossFactorTypeSelected,
      specialized
    );

    logActivity({
      screen : UserActivityConstants.SCREEN4.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action_target : specialized,
      action : UserActivityConstants.SCREEN4.ACTIONS.SELECT_INDUSTRY_OCCUPATION
    })
  };

  setFocusOccupation = (occupation) => {
    this.setState({ focusOccupation: occupation });
  };

  handleDataSourceToggle = () => {
    this.props.updateDataSources()
    logActivity({
      screen : UserActivityConstants.SCREEN4.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action_target : UserActivityConstants.COMMON_ACTIONS.TOGGLE_DATA_SOURCE,
      action : UserActivityConstants.COMMON_ACTIONS.TOGGLE_DATA_SOURCE
    })
  }

  render() {
    var industryTypes = Object.values(this.props.industryData);
    const hispanicLabels = [
      { name: "0-15%", color: "#860000" },
      { name: "15-30%", color: "#FF0011" },
      { name: "30-45%", color: "#FB6A59" },
      { name: "45-60%", color: "#FFB607" },
      { name: ">60%", color: "#FFE09A" },
    ];
    const educationLabels = [
      { name: "Bachelor's or Higher", color: "#6AA4DC" },
      { name: "Associates and Some College", color: "#FFB607" },
      { name: "High School or Lower", color: "#FB6A59" },
    ];
    const medianIncomeLabels = [
      { name: "<$36K", color: "#FF0011" },
      { name: "$36K-$51K", color: "#FB6A59" },
      { name: "$51K-$67K", color: "#FFB607" },
      { name: ">$67K", color: "#FFE09A" },
    ];
    const startingIncomeLabels = [
      { name: "<$36K", color: "#FF0011" },
      { name: "$36K-$51K", color: "#FB6A59" },
      { name: "$51K-$67K", color: "#FFB607" },
      { name: ">$67K", color: "#FFE09A" },
    ];
    const genderLabels = [
      { name: "Predominantly Male", color: "#6AA4DC" },
      { name: "Predominantly Female", color: "#FB6A59" },
    ];
    const crossFactorTypes = [
      { name: "Hispanic", label: hispanicLabels },
      { name: "Education Groups", label: educationLabels },
      { name: "Median Income", label: medianIncomeLabels },
      { name: "Starting Income", label: startingIncomeLabels },
      { name: "Gender", label: genderLabels },
    ];
    const specializedTypes = ["All Occupations", "Specialized"];

    var average_unemployment = this.props.averageDataScreen4[
      "average_unemployment"
    ];
    var average_leadership_equity = this.props.averageDataScreen4[
      "average_leadership_equity"
    ];
    var jobs_change_sum = this.props.averageDataScreen4["jobs_change_sum"];
    // const occupationData = OCCUPATION_BUBBLE_CHART_DATA;
    let growthData = Object.values(this.props.growthDataScreen4);

    return (
      <div className="screen-wrapper">
        <header className="screen-header">
          <IconButton
              id="data-sources-icon"
              style={{
                color: "white",
                marginLeft: 20,
                marginRight: -60,
                marginTop: -155,
                position: 'relative', // This is required for z-index to work
                zIndex: 1000,
              }}
              onClick={this.handleDataSourceToggle}
            >
              <LibraryBooksIcon className="swap-icon" />
            </IconButton>
          <div className="title">Occupation Overview</div>
        </header>
        <Grid
          container
          className="screen-content-wrapper screen-content-wrapper-4"
        >
          <Grid
            container
            className="screen-content-grid-4"
            style={{ height: "915px" }}
          >
            {/* <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div style={{ "backgroundColor": "#005898"}} className="rect-shape">
              </div>
            </Grid>
            <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div style={{ "backgroundColor": "#6AA4DC"}} className="rect-shape">
               </div>
            </Grid>
            <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div style={{ "backgroundColor": "#FFB607"}} className="rect-shape">
              </div>
            </Grid>
            <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div style={{ "backgroundColor": "#FB6A59"}} className="rect-shape">
              </div>
            </Grid>
            <Grid item md={2.4} className="aggregated-metric-wrapper" style={{paddingRight: 0}}>
              <div style={{ "backgroundColor": "#DE3E40"}} className="rect-shape">
              </div>
            </Grid> */}
            {/* <Grid item md={5}>
              <img key={1} className="left_placeholder" alt="" src={screen4_left} />
            </Grid>
            <Grid item md={7}>
              <img key={1} className="right_placeholder" alt="" src={screen4_right} />
            </Grid> */}

            <Grid item md={5.71} className="screen4-graph-container">
              <IndustryJobCounts
                industryTypes={industryTypes}
                industryTypeSelected={this.props.industryTypeSelectedS3}
                handleIndustryTypeChange={this.handleIndustryTypeChange}
                countData={this.props.countDataScreen4}
                percentData={this.props.percentDataScreen4}
                focusOccupation={this.state.focusOccupation}
                setFocusOccupation={this.setFocusOccupation}
                specializedTypes={specializedTypes}
                specializedTypeSelected={this.state.specializedSelected}
                handleSpecializedChange={this.handleSpecializedChange}
              />
            </Grid>
            <Grid item md={6.29} className="screen4-graph-container">
              <OccupationBubbleChart
                regionSelected={this.props.regionSelected}
                crossFactorTypes={crossFactorTypes}
                crossFactorTypeSelected={this.state.crossFactorTypeSelected}
                handleCrossFactorTypeChange={this.handleCrossFactorTypeChange}
                occupationData={growthData}
                focusOccupation={this.state.focusOccupation}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    industryData: { ...state.Screen3Reducer.industryData },
    orientationHorizontal: state.ScreensCommonReducer.orientationHorizontal,
    displayDataSources: state.ScreensCommonReducer.displayDataSources,
    regionSelected: state.Screen1Reducer.regionSelected,
    jobTypeSelectedS2: state.Screen2Reducer.jobTypeSelectedS2,
    industryTypeSelectedS3: state.Screen3Reducer.industryTypeSelectedS3,
    averageDataScreen4: { ...state.Screen4Reducer.averageDataScreen4 },
    countDataScreen4: { ...state.Screen4Reducer.countDataScreen4 },
    percentDataScreen4: { ...state.Screen4Reducer.percentDataScreen4 },
    growthDataScreen4: { ...state.Screen4Reducer.growthDataScreen4 },
    orientationHorizontal: state.ScreensCommonReducer.orientationHorizontal,
    regionSelected: state.Screen1Reducer.regionSelected,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchIndustryData,
      updateIndustryTypeS3,
      changeScreenOrientation,
      updateDataSources,
      fetchAverageDataScreen4,
      fetchCountDataScreen4,
      fetchPercentDataScreen4,
      fetchGrowthDataScreen4,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Screen4);
